export enum PaymentMethods {
    Alipay = 'alipay',
    Alterpay = 'alterpay',
    AustralianBank = 'au_bank',
    Avodapay = 'avodapay',
    BankWire = 'bank_wire',
    Bitcoin = 'PMR_BTC',
    BitWallet = 'BITWALLET',
    Bpay = 'bpay',
    BRG_INT = 'BRG_INT',
    BRG_EIG_CYSEC_CC = 'BRG_EIG_CYSEC_CC',
    BRG_FCS_BEETELLER = 'BRG_FCS_BEETELLER',
    BRG_H2P = 'BRG_H2P',
    BRG_HAYVN = 'BRG_HAYVN',
    BridgerPaypal = 'BRG_PYPL',
    BridgerWorldPay = 'bridger_worldpay',
    CHINA_APM = 'CHINA_APM',
    CLIPPAY = 'CLIPPAY',
    DIRECT_CRYPTO = 'DIRECTCRYPTO',
    Eximbay = 'BRG_FCS_CC',
    ECHELONPAY_FCS = 'ECHELONPAY_FCS',
    Fasapay = 'fasapay',
    IndoXPay = 'indo_xpay',
    InternationalBank = 'international_bank',
    LatinBank = 'BKAL',
    MalayXPay = 'malay_xpay',
    Neteller = 'neteller',
    None = '',
    OTC365 = 'OTC365',
    Paypal = 'paypal',
    PayRetailer = 'BRG_FCS',
    PAGSMILE = 'PAG_FCS',
    PAYQUAY = 'PAYQUAY',
    Philip = 'philip',
    Poli = 'poli',
    RpnCupDesktop = 'cup_desktop',
    RpnUSDT = 'RPNUSDT',
    Skrill = 'skrill',
    T365THB = 'T365THB',
    ThaiXPay = 'thai_xpay',
    Union = 'union',
    USDT_ETH = 'usdt_eth',
    USDT_TRON = 'usdt_tron',
    VietnamXPay = 'vietnam_xpay',
    Visa = 'visa'
}
